module.exports = __webpack_public_path__ + "static/media/hero.9cd7130a.jpg";